/** Констранты каталога ADMS */
export const ADMSRDF = {
  //Список пространства имён ADNS каталога
  NAMESPACES: [
    {owl: "http://www.w3.org/2002/07/owl#"},
    {rdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#"},
    {rdfs: "http://www.w3.org/2000/01/rdf-schema#"},
    {xml: "http://www.w3.org/XML/1998/namespace"},
    {xsd: "http://www.w3.org/2001/XMLSchema#"},
    {dcat: "http://www.w3.org/ns/dcat#"},
    {dct: "http://purl.org/dc/terms/"},
    {adms: "http://www.w3.org/ns/adms#"},
    {foaf: "http://xmlns.com/foaf/0.1/"},
    {skos: "http://www.w3.org/2004/02/skos/core#"},
    {wdrs: "http://www.w3.org/2007/05/powder-s#"},
    {voaf: "https://lov.linkeddata.es/vocommons/voaf/v2.3/"},
    {csi: "http://csi.semanticpro.org/2016/ns#"}
  ],
  PROPERTIES: {
    ASSET: [
      {URI: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type", TYPE:"http://www.w3.org/2002/07/owl#ObjectProperty"},
      {URI: "http://www.w3.org/ns/dcat#theme", TYPE: "http://www.w3.org/2002/07/owl#ObjectProperty"},     //Категории
      {URI: "http://purl.org/dc/terms/description", TYPE:"http://www.w3.org/2002/07/owl#AnnotationProperty"}, //Описание
      {URI: "http://purl.org/dc/terms/modified", TYPE:"http://www.w3.org/2002/07/owl#DatatypeProperty"},  //Дата обновления
      {URI: "http://purl.org/dc/terms/publisher", TYPE:"http://www.w3.org/2002/07/owl#ObjectProperty"},   //Издатель
      {URI: "http://purl.org/dc/terms/title", TYPE:"http://www.w3.org/2002/07/owl#AnnotationProperty"},   //Заглавие
      {URI: "http://purl.org/dc/terms/type", TYPE:"http://www.w3.org/2002/07/owl#ObjectProperty"},        //Тип 
      {URI: "http://www.w3.org/ns/adms#status", TYPE:"http://www.w3.org/2002/07/owl#ObjectProperty"},     //Статус
      {URI: "http://www.w3.org/ns/adms#interoperabilityLevel", TYPE:"http://www.w3.org/2002/07/owl#ObjectProperty"}, //Уровень интероперабельности
      {URI: "http://www.w3.org/ns/dcat#contactPoint", TYPE:"http://www.w3.org/2002/07/owl#ObjectProperty"}, //Контактная информация
      {URI: "http://www.w3.org/ns/dcat#distribution", TYPE:"http://www.w3.org/2002/07/owl#ObjectProperty"}, //Распространение
      {URI: "http://www.w3.org/ns/dcat#keyword", TYPE:"http://www.w3.org/2002/07/owl#DatatypeProperty"},    //Теги
      {URI: "http://www.w3.org/ns/dcat#landingPage", TYPE: "http://www.w3.org/2002/07/owl#ObjectProperty"}, //URL
      {URI: "http://purl.org/dc/terms/language", TYPE:"http://www.w3.org/2002/07/owl#ObjectProperty"},      //Язык
      {URI: "http://purl.org/dc/terms/relation", TYPE:"http://www.w3.org/2002/07/owl#DatatypeProperty"},    //Связанные ресурсы
      {URI: "http://purl.org/dc/terms/spatial", TYPE:"http://www.w3.org/2002/07/owl#ObjectProperty"},       //Территориальный охват
      {URI: "http://purl.org/dc/terms/temporal", TYPE:"http://www.w3.org/2002/07/owl#ObjectProperty"},      //Временной охват
      {URI: "http://www.w3.org/ns/adms#includedAsset", TYPE:"http://www.w3.org/2002/07/owl#ObjectProperty"},//Включаемые активы 
      {URI: "http://www.w3.org/ns/adms#last", TYPE:"http://www.w3.org/2002/07/owl#ObjectProperty"},         //Последняя версия
      {URI: "http://www.w3.org/ns/adms#next", TYPE:"http://www.w3.org/2002/07/owl#ObjectProperty"},         //Следующая версия
      {URI: "http://www.w3.org/ns/adms#prev", TYPE:"http://www.w3.org/2002/07/owl#ObjectProperty"},         //Предыдущая версия
      {URI: "http://www.w3.org/ns/adms#sample", TYPE:"http://www.w3.org/2002/07/owl#ObjectProperty"},       //Пример
      {URI: "http://www.w3.org/ns/adms#translation", TYPE:"http://www.w3.org/2002/07/owl#ObjectProperty"},  //Перевод
      {URI: "http://www.w3.org/ns/adms#versionNotes", TYPE:"http://www.w3.org/2002/07/owl#DatatypeProperty"},//Описание изменений
      {URI: "http://purl.org/dc/terms/issued", TYPE:"http://www.w3.org/2002/07/owl#DatatypeProperty"},      //Дата публикации
      {URI: "http://xmlns.com/foaf/0.1/page", TYPE:"http://www.w3.org/2002/07/owl#ObjectProperty"},         //Документация
      {URI: "http://www.w3.org/2002/07/owl#versionInfo", TYPE:"http://www.w3.org/2002/07/owl#DatatypeProperty"},//Версия
      {URI: "http://www.w3.org/2004/02/skos/core#altLabel", TYPE:"http://www.w3.org/2002/07/owl#AnnotationProperty"},//Альтернативное имя
      {URI: "http://www.w3.org/2007/05/powder-s#describedby", TYPE:"http://www.w3.org/2002/07/owl#ObjectProperty"},//Документация или спецификация
      {URI: "http://labs.mondeca.com/vocab/voaf#hasDisjunctionsWith", TYPE:"http://www.w3.org/2002/07/owl#ObjectProperty"},  //Имеет дизъюнкцию с
      {URI: "http://labs.mondeca.com/vocab/voaf#hasEquivalencesWith", TYPE:"http://www.w3.org/2002/07/owl#ObjectProperty"},  //Имеет эквиваленты
      {URI: "http://labs.mondeca.com/vocab/voaf#extends", TYPE:"http://www.w3.org/2002/07/owl#ObjectProperty"},  //Расширяет
      {URI: "http://labs.mondeca.com/vocab/voaf#generalizes", TYPE:"http://www.w3.org/2002/07/owl#ObjectProperty"},  //Обобщает
      {URI: "http://labs.mondeca.com/vocab/voaf#reliesOn", TYPE:"http://www.w3.org/2002/07/owl#ObjectProperty"},  //Импортирует
      {URI: "http://labs.mondeca.com/vocab/voaf#metadataVoc", TYPE:"http://www.w3.org/2002/07/owl#ObjectProperty"},  //Метаданные
      {URI: "http://labs.mondeca.com/vocab/voaf#specializes", TYPE:"http://www.w3.org/2002/07/owl#ObjectProperty"},  //Специализирует
      {URI: "http://www.w3.org/2004/02/skos/core#definition", TYPE:"http://www.w3.org/2002/07/owl#AnnotationProperty"}, //Описание
      {URI: "http://www.w3.org/2004/02/skos/core#prefLabel", TYPE:"http://www.w3.org/2002/07/owl#AnnotationProperty"}, //Наименование
      {URI: "http://www.w3.org/2004/02/skos/core#broader", TYPE:"http://www.w3.org/2002/07/owl#ObjectProperty"},  //Более общий
      {URI: "http://www.w3.org/2004/02/skos/core#narrower", TYPE:"http://www.w3.org/2002/07/owl#ObjectProperty"},  //Более детальный
    ],
  },
  TAXONOMY_SEQUENCE: ["http://purl.semanticpro.org/authority/asset-kind",
    "http://purl.semanticpro.org/authority/asset-type", "http://purl.semanticpro.org/schema/Purpose","http://purl.semanticpro.org/schema/DegreeOfDetail",
    "http://purl.semanticpro.org/schema/Consumers", "http://purl.semanticpro.org/schema/Content",
    "http://purl.semanticpro.org/authority/domain", "http://purl.semanticpro.org/schema/UsedDesignParadigm",
    "http://purl.semanticpro.org/schema/UseOfModelingLanguages"],
  /** Предикат (свойство) фиксация ссылки на индивидуал http://www.w3.org/ns/adms#AssetDistribution */
  PREDICAT_DISTRIBUTION: "http://www.w3.org/ns/dcat#distribution",
  /** Предикат (свойство) фиксация ссылки на wiki статьи */
  PREDICAT_WIKI : "http://hbz.ru/ontologies/emd/wiki",
  SKSA_PREDICAT_WIKI : "http://purl.semanticpro.org/ontologies/sksa/wiki"
}

/** Константы коллективной работы  */
export const TEAMWORK = {
  /** Предикат (свойство) ссылки на URL с wiki статьёй */
  PREDICAT_WIKI : "http://hbz.ru/ontologies/emd/wiki",
  SKSA_PREDICAT_WIKI : "http://purl.semanticpro.org/ontologies/sksa/wiki",
  /** Предикат (свойство) ссылки на элемент коллективной работы */
  PREDICAT_TW : "http://hbz.ru/ontologies/emd/teamwork",
  /** Предикат (свойство) ссылки на элемент каталога ADMS */
  PREDICAT_ASSET: "http://hbz.ru/ontologies/emd/adms",
  /** Предикат (свойство) ссылки на файл или папку */
  PREDICAT_FILE : "http://hbz.ru/ontologies/emd/dml",
}

/** Константы дублинского ядра  */
export const DCTERMS = {
  TITLE: "http://purl.org/dc/terms/title",
  DESCRIPTION: "http://purl.org/dc/terms/description",
  IDENTIFIER: "http://purl.org/dc/terms/identifier",
}

/** Wiki статьи */
export const WIKI = {
  /** Длина обрезки поля содержание для отображение в форме */
  CONTENT_PRUNING_SIZE: 128,
  PREDICAT: TEAMWORK.PREDICAT_WIKI,
}

/** Константы, используемые в window.localStorage */
export const LOCALSTORAGE = {
  /** Содержиме XSD файла */
  XSD: "LS_XSD"
}

/**  */
export const SIOC = {
  PREDICAT_LINK : "http://rdfs.org/sioc/ns#link"
};

export const RDFS = {
  PREDICAT_LABEL : "http://www.w3.org/2000/01/rdf-schema#label",
}

export const VANN = {
  PREFERREDNAMESPACEURI : "http://purl.org/vocab/vann/preferredNamespaceUri",
}